<template>
    <div class="overlay-wrap">
        <img :src="project.image">
        <div class="overlay" v-bind:class="project.overlayClass" @click="showDetail=true">
            <div class="overlay__text align--center">
                <h3 class="mb0">{{project.name}}</h3>
                <p class="mb1">{{project.tagline}}</p>
            </div>
        </div>
        <transition name="modal" v-if="showDetail">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container span-two-thirds" @click="showDetail=false">
                        <div class="modal-header">
                            <h3 class="mb0">{{project.name}}</h3>
                        </div>

                        <div class="modal-body">
                            <slot name="body">{{project.detail}}</slot>
                        </div>

                        <div class="modal-body" v-if="project.links.length > 0">
                            <h4 class="mb0">Sources</h4>
                            <span class="bold" v-for="link in project.links">
                               <a v-bind:href="link.value">{{link.type}}</a> &nbsp &nbsp
                            </span>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">initial release: {{project.release_time}}</slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
   name: 'project',
   props: {
       project: Object
   },
   data() {
       return {
           showDetail: false
       }
   }
}
</script>

<style lang="scss">
    @import '../scss/main.scss'
</style>


// WEBPACK FOOTER //
// src/components/Project.vue